export default {
  metaTitle: {
    id: 'price_guide_product_model_meta_title',
    defaultMessage:
      'How much does the {productModel} cost? | {dateMonthLongCapitalized} {dateYearNumeric}',
  },
} as const
